import React, { use, useState } from 'react';
import { categoryPerformanceDashbaord, adsAnalyse } from '../../../../services/adsAnalysis';
import { usePermissions } from '../../../../context/PermissionContext';
import { addColumnSetting } from '../../../../services/columnSetting';
 
const useAdsAnalysis= () => {

  const [categoryPerformanceState, setCategoryPerformanceState] = useState([]);
  const [adsAnalyseState, setAdsAnalyseState] = useState([]);
  const [adsAnalyseSequence, setAdsAnalyseSequence] = useState([]);
  const [adsAnalyseLoaded, setAdsAnalyseLoaded] = useState(false);
  const [selectedTab, setSelectedTab] = useState("all");
  const [accessDenied, setAccessDenied] = useState(false);
  const [loadingState,setLoadingState]=useState({
    adsAnalyseState:false,
    categoryPerformanceState:false,
  })
  const permission = usePermissions();

  const tabOptions = [
    { label: "All", value: "all" },
    { label: "High Impressions & Low Clicks", value: "low_ctr" },
    { label: "Good CTR & Low Conversion", value: "good_ctr_low_cvr" },
    { label: "High CPC & Low Conversion", value: "high_cpc_low_cvr" },
    { label: "High ROAS & Stable ACOS", value: "high_roas_stable_acos" },
    { label: "Zero Spend", value: "zero_spend" },
    { label: "Ad Spend Up & Orders Flat (Zero)", value: "ad_spend_up_order_zero" },
    { label: "Top ROAS & Low TACoS" , value:"top_roas_4_tacos_20"},
    { label: "Highest Conversion Rate" , value:"high_ctr_10"},
    { label: "High Spend & Low ROAS" , value:"spend_100_roas_2"},
    { label: "High ACOS" , value:"acos_50"},
    { label: "CR Buckets (0 to 2%)" , value:"cvr_0_2"},
    { label: "CR Buckets (2% to 5%)" , value:"cvr_2_5"},
    { label: "CR Buckets (6% to 10%)" , value:"cvr_10"},
    { label: "CR Buckets (+10%)" , value:"max_cvr_10"},
    { label: "Low Ad Spend & High CTR (0.5%)" , value:"high_ctr_low_spend"},
  ];


  const getCategoryPerformanceDashbaord = async ({ formattedEnd , formattedStart, selectedIds = [] , selectedTab}) =>{
    setLoadingState((prev)=>({
      ...prev,
      categoryPerformanceState:true
    }))
    try {
      let response = await categoryPerformanceDashbaord({ formattedEnd , formattedStart, selectedIds , selectedTab });
      if (response && response.success && response.data) {
        setCategoryPerformanceState(response.data);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
        // console.error('Failed category performance dashboard API calling :',error)
    }finally{
        setLoadingState((prev)=>({
        ...prev,
        categoryPerformanceState:false
      }))
    }
  }

  const getAdsAnalyse = async ({ formattedEnd , formattedStart , selectedIds = [] , selectedTab }) =>{
    setLoadingState((prev)=>({
      ...prev,
      adsAnalyseState:true
    }))
      setAdsAnalyseLoaded(false)
    try {
      let response = await adsAnalyse({ formattedEnd , formattedStart , selectedIds, selectedTab });
      if (response && response.success && response.data) {
        setAdsAnalyseState(response?.data);
        setAdsAnalyseSequence(response?.sequence);
      } else {
        console.error("Invalid response structure:", response);
      }
    } catch (error) {
      console.error('Failed ads analyse API calling :',error)
      if (error.status === 403){
        setAccessDenied(true)
      }
    } finally {
        setLoadingState((prev)=>({
        ...prev,
        adsAnalyseState:false
        }))
        setAdsAnalyseLoaded(true)
      }
  }
    const filteredTabs = React.useMemo(() => {
    const insightPermissions =
      permission?.data?.ads_analysis?.insights || {};

    return tabOptions
      .filter((tab) => {
        const perm = insightPermissions[tab.value];
        // Only exclude when both display = false AND access = false
        return !(perm?.display === false && perm?.allowed === false);
      })
      .map((tab) => {
        const perm = insightPermissions[tab.value];
        return {
          ...tab,
          permission: perm, // attach permission to drive blur/visible logic
        };
      });
  }, [tabOptions, permission]);
  const selectedTabPermission =
    permission?.data?.ads_analysis?.insights[selectedTab] || {};

  const tablePermission =
    permission?.data?.ads_analysis?.table_section.table_view || {};

  const combinedTablePermission = {
    display: selectedTabPermission.display && tablePermission.display,
    allowed: selectedTabPermission.allowed && tablePermission.allowed,
  };
  const canShowTable =
    (permission?.data?.ads_analysis?.view_format.category_wise.display &&
      permission?.data?.ads_analysis?.view_format.category_wise.allowed) ||
    (permission?.data?.ads_analysis?.view_format.product_wise.display &&
      permission?.data?.ads_analysis?.view_format.product_wise.allowed);

  const combinedPermission = {
    display:
      permission?.data?.ads_analysis?.view_format.category_wise.display ||
      permission?.data?.ads_analysis?.view_format.product_wise.display,
    allowed:
      permission?.data?.ads_analysis?.view_format.category_wise.allowed ||
      permission?.data?.ads_analysis?.view_format.product_wise.allowed,
  };

  return {
    combinedPermission,
    canShowTable,
    combinedTablePermission,
    filteredTabs,
    selectedTabPermission,
    loadingState,
    categoryPerformanceState,
    adsAnalyseState,
    getCategoryPerformanceDashbaord,
    getAdsAnalyse ,selectedTab, setSelectedTab , tabOptions,adsAnalyseSequence,adsAnalyseLoaded,accessDenied
  };
};

export default useAdsAnalysis;
